/**
 * <event-console-checkin> — the console's check-in destination: mounts the
 * SAME `<scan-view>` the door PWA mounts (`@momo/views/checkin`), scoped by
 * the console's own `consoleEventId` (never `admin/sale`'s
 * `selectedSaleEventId` — an unrelated "which event is the guest-issue flow
 * working on" cell). Zero I/O itself — `checkin.sync.ts` (web) is the sole
 * reconciler, mirroring the door PWA's own `.sync` files one-for-one against
 * the same shared `@momo/views/checkin` state cells.
 *
 * `<scan-view>` requests its camera with one unconditional constraint
 * (rear camera where the device has one, the only camera otherwise) — no
 * per-consumer prop, no second template. The bounded box below is this
 * console's own chrome, not the component's — `[contain:layout]`
 * establishes this wrapper as the containing block for the verdict splash's
 * `position:fixed` descendants, so a resolved verdict bounds itself to this
 * panel instead of the whole admin shell's viewport.
 */
import { SchmancyElement, schmancyElement } from "@mhmo91/schmancy/mixins";
import "@momo/views/checkin";
import { html } from "lit";

@schmancyElement("event-console-checkin")
export default class EventConsoleCheckin extends SchmancyElement {
	override render() {
		return html`
			<div class="relative aspect-video w-full max-w-3xl overflow-hidden rounded-2xl [contain:layout]">
				<scan-view></scan-view>
			</div>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"event-console-checkin": EventConsoleCheckin;
	}
}
